import { render, staticRenderFns } from "./AddAtractionsImage.vue?vue&type=template&id=e9cfa2ea&scoped=true"
import script from "./AddAtractionsImage.vue?vue&type=script&lang=js"
export * from "./AddAtractionsImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cfa2ea",
  null
  
)

export default component.exports